var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticStyle: { display: "flex", gap: "20px" } }, [
      _vm._m(0),
      _c(
        "div",
        { staticStyle: { display: "flex", "flex-direction": "column" } },
        [
          _c(
            "div",
            { staticStyle: { "font-size": "2em", "font-weight": "bold" } },
            [_vm._v("CFDE REVEAL")]
          ),
          _c(
            "div",
            { staticStyle: { "font-size": "1.5em", "font-weight": "bold" } },
            [
              _vm._v(
                " Tell us what you're researching. We'll surface candidate genes and mechanisms you may not have considered. "
              ),
            ]
          ),
          _c("div", { staticStyle: { "font-size": "1.2em" } }, [
            _vm._v(" All results are grounded in "),
            _c(
              "a",
              {
                attrs: { role: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("show-byor-tab")
                  },
                },
              },
              [_vm._v("computational analyses of biological data")]
            ),
            _vm._v(
              ". An LLM is used to find, filter, and interpret findings in the context of your research. "
            ),
          ]),
        ]
      ),
    ]),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticStyle: { height: "100px" },
        attrs: {
          src: "https://hugeampkpncms.org/sites/default/files/users/user32/kc_icons/kc_reveal.png",
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("ol", [
        _c("li", [
          _c("strong", [_vm._v("Search:")]),
          _vm._v(
            " For the best results, try entering a research question that combines a target gene, biological mechanism, tissue context, and disease phenotype. "
          ),
        ]),
        _c("li", [
          _c("strong", [_vm._v("Refine:")]),
          _vm._v(
            ' Review and edit the extracted search terms to ensure they perfectly capture your intent, and toggle on "Exploratory Mode" if you want the AI to bridge missing gaps in the data with speculative leaps. '
          ),
        ]),
        _c("li", [
          _c("strong", [_vm._v("Analyze & Export:")]),
          _vm._v(
            " Review the generated mechanistic hypotheses. Explore the biological mechanism maps automatically translated into the Biolink standard. Check the map's edges to see which connections are validated by the NCATS Translator. Download your full interactive report to continue your workflow. "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }